import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import Results from "../../../../Results";
import ErrorAlert from "../../../../../containers/ErrorAlert";
import LayoutManagerContainer from "../../../../../containers/LayoutManager";
import SearchTerm from "../../../../SearchTerm";
import styles from "../../../ProductListingPage.css";
import Facets from "../../../../Facets";
import { DELIMITER } from "../../../../ProductTile/ariaConstants";
import Faqs from "../../../../Faqs";
import CategoryHeaderLinks from "../../../../CategoryHeader/__variants__/plp-filtering-experience/v2/CategoryHeaderLinks";
import { getCategorySeoLinks } from "../../../../../state/modules/category/selectors";

const styleContext = classNames.bind(styles);

export const ProductListingPage = props => {
  const {
    hasFacets,
    isNewSearch,
    location: { search },
    viewportCategory
  } = props;
  const queryStringRef = useRef(search);
  const { current: queryString } = queryStringRef;
  const { primarySeoLinks } = useSelector(getCategorySeoLinks);

  useEffect(() => {
    if (queryString !== search) {
      queryStringRef.current = search;

      if (isNewSearch) {
        window.scrollTo(0, 0);
      }
    }
  }, [search]);

  return (
    <div
      className={styleContext({
        container: true,
        wrapper: hasFacets
      })}
    >
      <LayoutManagerContainer />
      <SearchTerm />
      {hasFacets && <Facets viewportCategory={viewportCategory} />}
      <Results {...props} />
      <Faqs />
      {primarySeoLinks.length > 0 && <CategoryHeaderLinks />}
      <ErrorAlert />
      <span className={styles.ariaDelimiter} id={DELIMITER}>
        ;
      </span>
    </div>
  );
};

ProductListingPage.propTypes = {
  isNewSearch: PropTypes.bool,
  location: PropTypes.object.isRequired,
  hasFacets: PropTypes.bool.isRequired,
  viewportCategory: PropTypes.string.isRequired
};

export default ProductListingPage;
